import { render, staticRenderFns } from "./InformationToPublish.vue?vue&type=template&id=48490eaf&scoped=true"
import script from "./InformationToPublish.vue?vue&type=script&lang=js"
export * from "./InformationToPublish.vue?vue&type=script&lang=js"
import style0 from "./InformationToPublish.vue?vue&type=style&index=0&id=48490eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48490eaf",
  null
  
)

export default component.exports